import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { EMPTY_STUDY_FILTER } from "../lib/studies";
import { Search, X } from "lucide-react";

export function StudySearch({ filter, setFilter, clinics, resultCount }) {
  const active = filter.q || filter.clinic_id || filter.from || filter.to;
  const clear = () => setFilter({ ...EMPTY_STUDY_FILTER });

  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 mb-4" data-testid="study-search">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4 items-end">
        <div className={clinics ? "lg:col-span-2" : "sm:col-span-2 lg:col-span-2"}>
          <Label className="text-[#373E45] font-semibold text-sm">Buscar (animal o código de caso)</Label>
          <div className="relative mt-1.5">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input value={filter.q} onChange={(e) => setFilter({ ...filter, q: e.target.value })}
              placeholder="Ej. Luna, MEN001…" className="pl-9 bg-white focus-visible:ring-[#7FD498]" data-testid="study-search-q" />
          </div>
        </div>
        {clinics && (
          <div>
            <Label className="text-[#373E45] font-semibold text-sm">Clínica</Label>
            <Select value={filter.clinic_id || "all"} onValueChange={(v) => setFilter({ ...filter, clinic_id: v === "all" ? "" : v })}>
              <SelectTrigger className="mt-1.5 bg-white" data-testid="study-search-clinic"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas las clínicas</SelectItem>
                {clinics.map((c) => <SelectItem key={c.id} value={c.id}>{c.clinic_name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        )}
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-[#373E45] font-semibold text-sm">Desde</Label>
            <Input type="date" value={filter.from} onChange={(e) => setFilter({ ...filter, from: e.target.value })} className="mt-1.5 bg-white" data-testid="study-search-from" />
          </div>
          <div>
            <Label className="text-[#373E45] font-semibold text-sm">Hasta</Label>
            <Input type="date" value={filter.to} onChange={(e) => setFilter({ ...filter, to: e.target.value })} className="mt-1.5 bg-white" data-testid="study-search-to" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mt-3">
        <span className="text-xs font-semibold text-[#64748B]" data-testid="study-search-count">{resultCount} resultado{resultCount === 1 ? "" : "s"}</span>
        {active && (
          <Button variant="ghost" size="sm" onClick={clear} className="text-[#64748B] hover:text-[#373E45] h-8" data-testid="study-search-clear">
            <X className="h-4 w-4 mr-1" />Limpiar filtros
          </Button>
        )}
      </div>
    </div>
  );
}
